<script setup>
    /**
     * Vue Scripts
     */
    import {ref} from "vue";
    import {globalStore} from "@pinia/global-store";
    import {handlePredictiveUrl, setPredictiveResult} from "@util/api";
    import {objNotEmpty} from "@util/mixins";

    /**
     * Vue Components
     */
    import PredictiveDropdown from "@component/PredictiveDropdown/PredictiveDropdown.vue";
    import SearchButton from "@component/SearchButton/SearchButton.vue";

    /**
     * GLOBAL Vars
     */
    const {
        formCta,
        formTitle,
        noResultsText,
        searchBtnText,
        searchPlaceholder
    } = HOME;
    const {predictiveApi,} = API;

    const {searchUrl} = globalStore()
    const searchedItem = ref({});

    /**
     * Take the user directly to the page if it is a generated
     * result, or take the user to the Search page if it is
     * a search term
     *
     * @param {String} name The name of the selected item
     * @param {String} url  The URL of the selected item
     */
    const goToLink = ({name, url}) => handlePredictiveUrl({name, url})

</script>

<template>
    <form id="trial-search"
          ref="antidoteForm"
          :action="searchUrl"
          class="predictive-search-form">
        <div class="form-header">
            <label for="vue-search-trials"
                   v-text="formTitle" />
            <a v-if="objNotEmpty(formCta)"
               :href="formCta?.url || ''"
               :target="formCta.target"
               v-text="formCta.title"/>
        </div>
        <div class="form-body">
            <PredictiveDropdown
                id="vue-search-trials"
                label="name"
                :api="predictiveApi"
                clearOnSelect
                :placeholder="searchPlaceholder"
                :noResults="noResultsText"
                @getResult="goToLink"
            />
            <SearchButton
                :button-text="searchBtnText"
                @clickAction="setPredictiveResult(searchedItem)"
            />
        </div>
    </form>
</template>

<script>
    export default {
        name: "Homepage Predictive Search"
    }
</script>

<style lang="scss" scoped>
    .dropdown__container {
        position: relative;
        min-height: 100px;
    }
    .form-body {
        .vs__dropdown-menu {
            max-height: fit-content;
        }
    }
</style>
